import util from '@/common/util';
import { renderHtml } from '@/common/utils/decode-html';

export default {
    components: {
        renderHtml
    },
    data: function() {
        return {
            html: '',
            isClient: util.isClient
        };
    },
    watch: {
        html() {
            //  solve cms redo When the module is rendered empty （ Modules don't update ）
            // cms The passed value will not end with a space
            if (!this.html.endsWith(' ')) {
                this.html = this.html + ' ';
            }
        }
    },
    computed: {
        isMobileSize() {
            return this.platform.isMobile;
        },
        paddingTop() {
            return (
                (this.isMobileSize ? this.mobileTopSpacing : this.topSpacing) +
                'px'
            );
        },
        marginBottom() {
            return (
                (this.isMobileSize ? this.mobileBtmSpacing : this.btmSpacing) +
                'px'
            );
        },
        minHeight() {
            if (util.inCmsPageEditor) {
                return '80px';
            }
            return null;
        }
    }
};
